import { useEffect, useMemo, useState } from "react";
import { getFirstLetterCapital, generateTrackingObject } from "@core/global/global-country-functions";
import ReactCountryFlag from "react-country-flag";
import ReactTooltip from "react-tooltip";
import ReactTableTrademo from "@shared/trademo-datatable/react-table-trademo";
import styles from "./TableData.module.scss";
import { getFavouriteDetailsHandler } from "@redux/Bookmark/bookmark.action";
import { useDispatch, useSelector } from "react-redux";
import { FavouriteSingleDeleteModal } from "@components/templates/Favourite/FavouriteSingleDeleteModal";
import moment from "moment";
import { loadingBookmarkData } from "@redux/Bookmark/bookmarksSlice";
import { noTags, profileType } from "../../../../utils/enum";
import { shipmentsPayload, pendoEventType } from "../../utils/constant";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import getTrackingEventDictionary from "@core/dictionary/tracking-event";
import ViewShipment from "@components/ViewShipments/view-shipments";
import Notes from "@shared/notes";
import { CountryCodeOneToOneMap, DATASET_TYPE_MAPPING } from "@core/dictionary/global";

export const TableData = ({ sortField, setSortField, singleData, sortOrderValue, setSortOrderValue, sortEnum, setSingleData, setSelectedCompanyArray, selectedCompanyArray, setShowFavModal, clearSelectedCompanies, type, payload, setPayload, perPage, setPerPage, currentpage, setCurrentPage }) => {
  const [showSingleData, setShowSingleData] = useState(false);
  const [currentPlan, setCurrentPlan] = useState("");
  const userDetails = useSelector((state) => state.userDetails);
  const state = useSelector((state) => state.bookmarkDetails.bookmarkData);
  const GLOBALPLAN = userDetails?.creditDetails?.data?.find((data) => data?.is_active && data?.user_active_plan?.toLowerCase()?.includes("global"))?.navigate === "search";

  let paginateCount = 60;
  const dispatch = useDispatch();

  const favouriteCompaniesColumns = useMemo(() => {
    let column = [
      {
        name: "",
        wrap: true,
        maxWidth: "50px !important",
        minWidth: "50px !important",
        selector: (row) => (
          <span>
            <ViewShipment rowData={row} countryName={GLOBALPLAN ? "global data" : (row?.data_source?.split(" ")?.[0] ?? "")} countryType={row.trade_direction} currentUserPlan={currentPlan} isSalesForceRedirection={false} analyticsCountryID={row?.data_source?.toUpperCase() + "S"} pathname={window.location.pathname} isRedirect={false} showExpandIcon={true} hideBookMark={true} type={row.redirectionkey} from="dashboard" />
          </span>
        ),
      },
      {
        name: "S. No",
        selector: "serial_no",
        maxWidth: "50px !important",
        minWidth: "50px !important",
      },
      {
        name: "Added On",
        wrap: true,
        maxWidth: "100px !important",
        minWidth: "100px !important",
        key: "date",
        sortable: true,
        selector: (row) => <div>{moment(row.created_at).format("MMM DD, YYYY")}</div>,
      },
      {
        name: "Data Source",
        wrap: true,
        maxWidth: "180px",
        minWidth: "180px",
        selector: (row) => (
          <div className="d-flex justify-content-between">
            {row?.data_source ? (
              <div className="text-capitalize tw-flex tw-items-center">
                {CountryCodeOneToOneMap[row.country_code.toLowerCase()] ? <ReactCountryFlag className="trademo-search-flag mr-2" countryCode={CountryCodeOneToOneMap[row.country_code.toLowerCase()]} svg /> : <ReactCountryFlag className="trademo-search-flag mr-2" countryCode={row.country_code} svg />}
                {(row?.data_source === "mexico maritime import" && "Mexico Import") || (row?.data_source === "mexico maritime export" && "Mexico Export") || (row?.data_source === "russia nm import" && "Russia Import") || (row?.data_source === "russia nm export" && "Russia Export") || (row?.data_source === "indonesia nm import" && "Indonesia Import") || (row?.data_source === "indonesia nm export" && "Indonesia Export") || getFirstLetterCapital(row?.data_source)}
                {DATASET_TYPE_MAPPING[`${row?.country_code?.toLowerCase()}_${row?.trade_direction}`]}
              </div>
            ) : (
              <span className={styles.noDataText}>NA</span>
            )}
            <Notes comingFrom="dashboard" count={row.notes_count} id={row.id} profileType={profileType.shipments} />
          </div>
        ),
      },
      {
        name: "Shipment Date",
        wrap: true,
        maxWidth: "100px !important",
        minWidth: "100px !important",
        selector: (row) => <div className="d-flex">{moment(row.shipment_date).format("MMM DD, YYYY")}</div>,
      },
      {
        name: "Tags",
        wrap: true,
        grow: 8,
        maxWidth: "250px !important",
        minWidth: "250px !important",
        selector: (row) => (
          <div
            onClick={() => {
              setShowFavModal(true);
              let rowData = { ...row };
              delete rowData.shipment_date;
              setSingleData(rowData);
              trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "add_edit_tag", { ...generateTrackingObject(`intel-${type}-favourite`) });
            }}>
            {row?.tags?.length && row.tags.filter((filterKey) => filterKey !== noTags).length ? (
              <div className="d-flex align-items-center flex-wrap">
                {row?.tags?.map((item) => (
                  <span key={item} data-tip={item} data-for="datatipID" className={`${styles.simpleTag} mr-1`}>
                    {item ? item.slice(0, 30) : ""}
                    {!!item && item.length > 30 ? "..." : ""}
                  </span>
                ))}
                {row?.tags?.length > 0 && row.tags.filter((filterKey) => filterKey !== noTags).length > 0 ? (
                  <span className={`${styles.simpleEditTag} cursor-pointer`}>
                    <p className="m-0">edit</p>
                  </span>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <span className={`d-flex align-items-center cursor-pointer ${styles.simpleEditTag}`}>add tag</span>
            )}
            <ReactTooltip className="trademo-tooltip" textColor="#FFFFFF" place="top" id="datatipID" />
          </div>
        ),
      },
      {
        name: "Actions",
        wrap: true,
        selector: (row) => (
          <div className="cursor-pointer d-flex">
            <span
              onClick={() => {
                if (selectedCompanyArray.length === 0) {
                  let rowData = { ...row };
                  delete rowData.shipment_date;
                  setSingleData(rowData);
                  setShowSingleData(true);
                  trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "delete", { ...generateTrackingObject(`intel-${type}-favourite`) });
                }
              }}
              className="mx-2">
              <ReactTooltip className="trademo-tooltip" textColor="#FFFFFF" place="top" id="deleteFavourite" />
              <span data-tip={"Remove"} data-for="deleteFavourite" className={`material-symbols-outlined ${styles.favIcon}`}>
                delete
              </span>{" "}
            </span>
          </div>
        ),
      },
    ];
    if (GLOBALPLAN) {
      column = column.filter((item) => item.name !== "Data Source");
    }
    return column;
  }, [type, sortField, sortOrderValue, GLOBALPLAN]);

  useEffect(() => {
    for (let i = 0; i < userDetails.userData.planIds.length; i++) {
      if (userDetails.userData.planIds?.navigate === "navigate") {
        setCurrentPlan(userDetails.userData.planIds.planId);
      }
    }
  }, [userDetails?.userData?.planIds]);

  useEffect(() => {
    setCurrentPage(1);
  }, [payload]);

  const handleTrademoTablePageChange = (page, perPage) => {
    setPerPage(perPage);
    setCurrentPage(page);
    const requiredValue = page * perPage;
    if (!(!!state?.data[requiredValue + 1] && state?.data[requiredValue + 1] !== "") && requiredValue + 1 < state?.filteredFavouriteDataCount) {
      let payloadClone = { ...payload };
      payloadClone.from = payloadClone.from + paginateCount;
      dispatch(loadingBookmarkData());
      dispatch(getFavouriteDetailsHandler({ payload: payloadClone, type: "pagination" }));
      setPayload(payloadClone);
    }
  };

  const handleSorting = (column, sortDirection) => {
    let payloadClone = { ...payload };
    setCurrentPage(1);
    setSortField(column);
    dispatch(loadingBookmarkData());
    setSortOrderValue(sortDirection);
    payloadClone.sort = sortDirection;
    setPayload(payloadClone);
    dispatch(getFavouriteDetailsHandler({ payload: payloadClone }));
    trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "sorting", { ...generateTrackingObject(`intel-${type}-favourite`) });
  };

  return (
    <div className="mt-3">
      <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="id_1" />
      <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="id_2" />
      <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="id_3" />
      <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="id_4" />
      <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="shipment-company-array-tooltip" />
      <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id="hs-code-inline-tooltip" />
      <ReactTableTrademo
        columns={favouriteCompaniesColumns}
        data={state.data}
        onSelectedRowsChange={(data) => {
          let customData = JSON.parse(JSON.stringify(data));
          customData.forEach((selectedRow) => {
            if (selectedRow?.shipment_date) {
              delete selectedRow?.shipment_date;
            }
          });
          setSelectedCompanyArray(customData);
        }}
        selectedData={selectedCompanyArray}
        paginationTotalRows={state?.filteredFavouriteDataCount || 0}
        clearSelectedRows={clearSelectedCompanies}
        paginationPerPage={perPage}
        paginationDefaultPage={currentpage}
        onChangeRowsPerPage={(data) => {
          setPerPage(data);
        }}
        onTableObjectChange={(data) => {
          setPerPage(data.perPage);
          setCurrentPage(data.currentPage + 1);
        }}
        onChangePage={(page, perPage) => {
          handleTrademoTablePageChange(page, perPage);
        }}
        hideBorder={true}
        hideSorting={true}
        onSort={(column, sortDirection) => {
          handleSorting(column, sortDirection);
        }}
        defaultSortField={sortField}
        defaultSortAsc={sortOrderValue === "desc" ? false : true}
        shipmentDefaultSortValue={sortEnum}
        sortOrderValue={sortOrderValue}
      />
      {showSingleData ? <FavouriteSingleDeleteModal setCurrentPage={setCurrentPage} setSingleData={setSingleData} setPayload={setPayload} type={type} payload={shipmentsPayload} selectedCompany={singleData} showSingleData={showSingleData} setShowSingleData={setShowSingleData} /> : ""}
    </div>
  );
};
